import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

export const TimelineIcon = createIcon({
  displayName: 'TimelineIcon',
  viewBox: '0 0 24 24',
  path: (
    <g fill='currentColor'>
      <circle cx='5' cy='7' r='1.8' />
      <circle cx='5' cy='12' r='1.8' />
      <circle cx='5' cy='17' r='1.8' />
      <rect x='9' y='6' width='11' height='2' rx='1' />
      <rect x='9' y='11' width='11' height='2' rx='1' />
      <rect x='9' y='16' width='11' height='2' rx='1' />
    </g>
  ),
});
